import { useLocation } from 'react-router';

import { CREATE_ROUTE_NAME } from '@/constants';
import useRequestId from '@/hooks/useRequestId';

const useLeasingRequestId = () => {
  const location = useLocation();
  const { requestId } = useRequestId();

  const isCreateMode = requestId === CREATE_ROUTE_NAME;

  const locationState = location.state as { requestId?: string } | null;
  const locationRequestId = locationState?.requestId || '';

  const computedRequestId: string = isCreateMode
    ? locationRequestId
    : requestId;

  return { requestId: computedRequestId, isCreateMode };
};

export default useLeasingRequestId;
